import { useQuery } from '@tanstack/react-query'
import { useOrganization } from '../../organizations/providers/OrganizationProvider'
import { getApprovalOverview } from '../api/getApprovalOverview'

export function useApprovalOverview() {
  const { organization } = useOrganization()

  return useQuery({
    queryKey: ['approval-overview', organization?.id, organization?.source],
    queryFn: () => getApprovalOverview(organization),
    staleTime: 30_000,
  })
}